import ModeEditIcon from "@mui/icons-material/Edit";
import { grey, red } from "@mui/material/colors";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import {
  getFormattedTimeStamp,
  getShiftDate,
  parsePreferredLeaveTime,
  parseRequestShiftTime,
} from "../util/dateTimeFormatter";
import TimeOffRequestDialog from "./TimeOffRequestDialog.jsx";
import { isLWOPTOWOPAllDayRequest, isLWOPTOWOPRequest } from "../util/timeOffRequestUtils.js";

const useStyles = makeStyles((theme) => ({
  torListItem: {
    minHeight: "60px",
    margin: "10px",
    padding: "10px",
    textAlign: "left",
  },
  edit: {
    color: theme.palette.primary.swaBlue,
    marginRight: "10px",
    bottom: "11px",
    position: "relative",
    float: "right",
  },
}));

const TimeOffRequestTableMobile = ({
  timeOffRequestsList,
  handleOnEditTimeOffRequest,
  isDesktopView,
  isEditable = true,
  showTransactions = false,
}) => {
  const classes = useStyles();
  const [isTimeOffRequestDialogOpen, setIsTimeOffRequestDialogOpen] = useState(false);
  const [selectedTimeOffRequest, setSelectedTimeOffRequest] = useState(null);

  const handleOnTimeOffRequestClick = (timeOffRequest) => {
    if (isEditable) {
      handleOnEditTimeOffRequest(timeOffRequest);
    } else {
      setIsTimeOffRequestDialogOpen(true);
      setSelectedTimeOffRequest(timeOffRequest);
    }
  };

  const handleOnCloseDialog = () => {
    setIsTimeOffRequestDialogOpen(false);
  };

  const renderShiftTime = (timeOffType, shiftStartDateTime, shiftEndDateTime, wopASAP, parsedPreferredLeaveTime) => {
    if (isLWOPTOWOPRequest(timeOffType) && !isLWOPTOWOPAllDayRequest(timeOffType)) {
      const preferredLeaveTime = wopASAP ? "ASAP" : parsedPreferredLeaveTime;
      return `${preferredLeaveTime} (Shift: ${parseRequestShiftTime(shiftStartDateTime, shiftEndDateTime)})`;
    } else return parseRequestShiftTime(shiftStartDateTime, shiftEndDateTime);
  };

  const getParsedPreferredLeaveTime = (timeOffRequest) => {
    if (timeOffRequest?.preferredWOPStart && timeOffRequest?.preferredWOPEnd) {
      return parsePreferredLeaveTime(timeOffRequest?.preferredWOPStart, timeOffRequest?.preferredWOPEnd);
    } else if (timeOffRequest?.preferredWOPStartTime && timeOffRequest?.preferredWOPEndTime) {
      return parsePreferredLeaveTime(timeOffRequest?.preferredWOPStartTime, timeOffRequest?.preferredWOPEndTime);
    }
    return "";
  };

  const renderEmployeeTrade = () => {
    return (
      <div>
        {timeOffRequestsList?.map((timeOffRequest) => {
          const { isExpired } = timeOffRequest;
          const color = isExpired ? red[500] : grey[900];
          const shiftStartDateTime = timeOffRequest?.shiftStartDateTime || timeOffRequest?.shiftStart;
          const shiftEndDateTime = timeOffRequest?.shiftEndDateTime || timeOffRequest?.shiftEnd;
          const timeOffType = timeOffRequest?.timeOffType || timeOffRequest?.timeOffRequestType;
          const wopASAP = timeOffRequest?.wopASAP;
          const parsedPreferredLeaveTime = getParsedPreferredLeaveTime(timeOffRequest);
          return (
            <Paper
              key={timeOffRequest?.id}
              className={classes.torListItem}
              elevation={1}
              onClick={() => handleOnTimeOffRequestClick(timeOffRequest)}
            >
              <div>
                <div className="shift-trade-current-user" style={{ color }}>
                  {timeOffType}{" "}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ color }}>
                    {getShiftDate(shiftStartDateTime)}{" "}
                    {shiftStartDateTime &&
                      shiftEndDateTime &&
                      renderShiftTime(
                        timeOffType,
                        shiftStartDateTime,
                        shiftEndDateTime,
                        wopASAP,
                        parsedPreferredLeaveTime
                      )}
                  </span>
                  {isEditable && (
                    <span>
                      <ModeEditIcon className={classes.edit} />
                    </span>
                  )}
                </div>
                {showTransactions && (
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>
                      {timeOffRequest?.visibleStatus} | {getFormattedTimeStamp(timeOffRequest?.lastUpdatedDate)}
                    </span>
                  </div>
                )}
              </div>
            </Paper>
          );
        })}
      </div>
    );
  };

  return (
    <div data-testid="time-off-request-table-mobile">
      {renderEmployeeTrade()}

      {isTimeOffRequestDialogOpen && (
        <TimeOffRequestDialog
          timeOffRequest={selectedTimeOffRequest}
          handleClickDialogClose={() => handleOnCloseDialog()}
          isAdminPage={false}
          isDialogOpen={isTimeOffRequestDialogOpen}
          isDesktopView={isDesktopView}
        />
      )}
    </div>
  );
};

TimeOffRequestTableMobile.propTypes = {};
export default TimeOffRequestTableMobile;
